import Service, { service } from '@ember/service';
import { action } from '@ember/object';
import { track, PostHogTracker } from 'scaleflow/utils/trackers';
import { getOwner } from '@ember/application';
const EVENTS = {
  SIDE_PANEL_OPEN: 'Side Panel Open',
  INITIATIVE_TABLE_CLICK: 'Click on Initiative Table',
  INITIATIVE_OPENED: 'Initiative Opened',
  INITIATIVE_UPDATE_OPENED: 'Initiative Update Wizard Opened',
  LOGGED_OUT: 'Logged Out',
};

export const doNotTrackTenantIds = ['2'];

export default class TrackerService extends Service {
  @service('organisation') organisationService;
  doNotTrack = {
    tenant_id: doNotTrackTenantIds,
  };

  trackers = {};

  initialise() {
    try {
      this.initialisePosthogTracker();
      console.debug('Trackers initialized');
    } catch (err) {
      console.error('Trackers failed to initialize', err);
    }
  }

  initialisePosthogTracker() {
    const posthogInstance = getOwner(this).lookup('posthog:client');
    if (!posthogInstance) return;
    const posthog = new PostHogTracker(posthogInstance);
    this.trackers.posthog = posthog;
  }

  @track
  trackPage(tracker, options) {
    tracker.trackPage(options);
  }

  @track
  setUserId(tracker, id, properties, set_once_properties) {
    tracker.setUserId(id, properties, set_once_properties);
  }

  @track
  setTenant(tracker, id, properties) {
    tracker.setTenant(id, properties);
  }

  @track
  setVersion(tracker, version) {
    tracker.setVersion(version);
  }

  @track
  reset(tracker) {
    tracker.reset();
  }

  @track
  trackSlideoverOpenedEvent(tracker, initiative_id) {
    tracker.track(EVENTS.SIDE_PANEL_OPEN, {
      initiative_id,
    });
  }

  /**
   * Adding an @action decorator provides the 'this' context
   * when executing this function through a modifer
   */
  @action
  @track
  trackInitiativesTableInteractionEvent(tracker, initiative_id = undefined) {
    let options = initiative_id ? { initiative_id } : undefined;
    tracker.track(EVENTS.INITIATIVE_TABLE_CLICK, options);
  }

  @track
  trackInitiativeOpenedEvent(tracker, initiative_id) {
    tracker.track(EVENTS.INITIATIVE_OPENED, { initiative_id });
  }

  @track
  trackInitiativeUpdateEvent(tracker, initiative_id) {
    tracker.track(EVENTS.INITIATIVE_UPDATE_OPENED, { initiative_id });
  }

  @track
  trackLogout(tracker) {
    tracker.track(EVENTS.LOGGED_OUT);
  }
}
